export default "__VITE_ASSET__b37e7006__"